import { useEffect } from "react";

const AdBannerTest = () => {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.warn("Adsense test error", e);
    }
  }, []);

  return (
    <div style={{ margin: "1rem auto", textAlign: "center" }}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-3940256099942544"  // ✅ cliente de prueba
        data-ad-slot="6300978190"                 // ✅ slot de prueba
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default AdBannerTest;
